const closed = require('./closed');
const letterSelected = require('./letterSelected');
const opened = require('./opened');
const queryChanged = require('./queryChanged');
const resultClosed = require('./resultClosed');
const resultSelected = require('./resultSelected');

module.exports = {
    closed,
    letterSelected,
    opened,
    queryChanged,
    resultClosed,
    resultSelected
};
